import UploadsService from '../../services/apiRequests/servorgs/uploads.service';
import { LocaleService } from '../../services/storage.service';
import { getFilterObject } from '../../utils/filter.util';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export default {
    namespaced: true,
    state: {
        uploadsList: [],
        uploadsListFilter: {},
        servorgUsers: [],
        statusList: [],
        formListPagination: {
            itemsPerPage: 10,
            page: 1
        },
        uploadsLength: null,
        uploadsLoading: false,
        filter: null,
        fileDetail: {},
        status: null,

        previewData: [],
        previewDataLoading: false,
        previewDataLength: 0,
        previewDataPagination: {},
        previewDataFilter: [],
        previewDataUnformattedFilter: {},

        groupedData: [],
        groupedDataLoading: false,
        groupedDataLength: 0,
        groupedDataPagination: {
            itemsPerPage: 10,
            page: 1,
            sortBy: []
        },
        groupedDataFilter: [],
        groupedDataUnformattedFilter: {},

        factData: [],
        factDataLoading: false,
        factDataLength: 0,
        factDataPagination: {},
        factDataFilter: [],
        factDataUnformattedFilter: {}
    },
    getters: {},
    mutations: {
        setUploadsList(state, uploadsList) {
            state.uploadsList = uploadsList;
        },
        setUploadsListFilter(state, uploadsListFilter) {
            state.uploadsListFilter = uploadsListFilter;
        },
        setServorgUsers(state, servorgUsers) {
            state.servorgUsers = servorgUsers;
        },
        setStatusList(state, statusList) {
            state.statusList = statusList;
        },
        setFormListPagination(state, formListPagination) {
            state.formListPagination = formListPagination;
        },
        setUploadsLegth(state, uploadsLength) {
            state.uploadsLength = uploadsLength;
        },
        setUploadsLoading(state, uploadsLoading) {
            state.uploadsLoading = uploadsLoading;
        },
        setFilter(state, filter) {
            state.filter = filter;
        },
        setFileDetail(state, fileDetail) {
            state.fileDetail = fileDetail;
        },
        setFileStatus(state, fileStatus) {
            state.status = fileStatus;
        },
        // предпросмотр данных файла
        setPreviewData(state, previewData) {
            state.previewData = previewData;
        },
        setPreviewDataLoading(state, previewDataLoading) {
            state.previewDataLoading = previewDataLoading;
        },
        setPreviewDataLength(state, previewDataLength = 0) {
            state.previewDataLength = previewDataLength;
        },
        setPreviewDataPagination(state, previewDataPagination) {
            state.previewDataPagination = previewDataPagination;
        },
        setPreviewDataFilter(state, previewDataFilter) {
            state.previewDataFilter = previewDataFilter;
        },
        setPreviewDataUnformattedFilter(state, filter) {
            state.previewDataUnformattedFilter = filter;
        },
        // сгруппированные данные
        setGroupedData(state, groupedData) {
            state.groupedData = groupedData;
        },
        setGroupedDataLoading(state, groupedDataLoading) {
            state.groupedDataLoading = groupedDataLoading;
        },
        setGroupedDataLength(state, groupedDataLength = 0) {
            state.groupedDataLength = groupedDataLength;
        },
        setGroupedDataPagination(state, groupedDataPagination) {
            state.groupedDataPagination = groupedDataPagination;
        },
        setGroupedDataFilter(state, groupedDataFilter) {
            state.groupedDataFilter = groupedDataFilter;
        },
        setGroupedDataUnformattedFilter(state, filter) {
            state.groupedDataUnformattedFilter = filter;
        },
        // фактически загружаемые данные
        setFactData(state, factData) {
            state.factData = factData;
        },
        setFactDataLoading(state, factDataLoading) {
            state.factDataLoading = factDataLoading;
        },
        setFactDataLength(state, factDataLength) {
            state.factDataLength = factDataLength;
        },
        setFactDataPagination(state, factDataPagination) {
            state.factDataPagination = factDataPagination;
        },
        setFactDataFilter(state, factDataFilter) {
            state.factDataFilter = factDataFilter;
        },
        setFactDataUnformattedFilter(state, filter) {
            state.factDataUnformattedFilter = filter;
        }
    },
    actions: {
        async getUploadsList({ commit, state }, payload) {
            try {
                commit('setUploadsLegth', 0);
                commit('setUploadsLoading', true);
                const options = state.formListPagination;
                let response;
                if (options.sortBy[0] || state.filter) {
                    const locale = LocaleService.getLocale();
                    // определяем язык интерфейса
                    const JSONToSend = {
                        locale: locale === 'ru' ? '___ru' : '___kz'
                    };
                    // Если задана сортировака
                    if (options.sortBy[0]) {
                        JSONToSend.order = [{ field: options.sortBy[0], order_by: options.sortDesc[0] === true ? 'desc' : 'asc' }];
                    }
                    // если задан фильтр
                    if (state.filter) {
                        JSONToSend.where = state.filter.where;
                    }
                    // функция с возможностью сортировки и фильтрации. Отправляем JSON с данными по фильтрации и сортировки
                    response = await UploadsService.filter(0, options.itemsPerPage, options.itemsPerPage * (options.page - 1), JSONToSend);
                } else {
                    // функция без JSON'а. Используется когда страница только загрузилась, и когда фильтр или сортировка не заданы
                    response = await UploadsService.get(0, options.itemsPerPage, options.itemsPerPage * (options.page - 1));
                }

                if (response[0]) {
                    commit('setUploadsLegth', Number(response[0].record_count));
                }
                commit('setUploadsList', response);
            } catch (err) {
                console.error(err);
            } finally {
                commit('setUploadsLoading', false);
            }
        },

        async getFileDetail({ commit }, id) {
            try {
                let response = await UploadsService.getFileDetail(id);
                commit('setFileDetail', response);

                if (response && response.status_name) {
                    commit('setFileStatus', response.status_name.name___ru);
                }

                return response;
            } catch (err) {
                console.error(err);
            }
        },

        async getFileMeters({ commit }, id) {
            try {
                let response = await UploadsService.getFileMeters(id);
                return response;
            } catch (err) {
                console.error(err);
            }
        },

        async getServorgsUsers({ commit }, payload) {
            let response = await UploadsService.getServorgUsers();
            commit('setServorgUsers', response);
        },

        async getStatusList({ commit }) {
            let response = await UploadsService.getStatusList();
            commit('setStatusList', response);
        },

        async uploadFile({ commit }, file) {
            let response = await UploadsService.uploadFile(file);
            return response;
        },

        async previewFile({ commit }, id) {
            try {
                commit('setPreviewDataLoading', true);
                commit('setGroupedDataLoading', true);
                let response = await UploadsService.previewFile(id);
                return response;
            } catch (err) {
                console.error(err);
            } finally {
                commit('setPreviewDataLoading', false);
                commit('setGroupedDataLoading', false);
            }
        },

        async getPreviewData({ commit, state }, payload) {
            try {
                commit('setPreviewDataLoading', true);
                const options = state.previewDataPagination;
                let response;
                if (options.sortBy[0] || state.previewDataFilter) {
                    const JSONToSend = getFilterObject(options, state.previewDataFilter);
                    // функция с возможностью сортировки и фильтрации. Отправляем JSON с данными по фильтрации и сортировки
                    response = await UploadsService.getPreviewData(payload.fileID, options.itemsPerPage, options.itemsPerPage * (options.page - 1), JSONToSend);
                } else {
                    response = await UploadsService.getPreviewData(payload.fileID, options.itemsPerPage, options.itemsPerPage * (options.page - 1));
                }
                if (response && response.length) {
                    for (let i = 0; i < response.length; i++) {
                        response[i].id = i + uuidv4();
                    }
                }
                commit('setPreviewData', response);
                if (response && response[0]) commit('setPreviewDataLength', Number(response[0].record_count));
                else commit('setPreviewDataLength', 0);
                return response;
            } catch (err) {
                console.error(err);
            } finally {
                commit('setPreviewDataLoading', false);
            }
        },

        async getGroupedData({ state, commit }, id) {
            try {
                commit('setGroupedDataLoading', true);
                const options = state.groupedDataPagination;
                let response;
                if ((options.sortBy && options.sortBy[0]) || state.groupedDataFilter) {
                    const JSONToSend = getFilterObject(options, state.groupedDataFilter);
                    // функция с возможностью сортировки и фильтрации. Отправляем JSON с данными по фильтрации и сортировки
                    response = await UploadsService.getGroupedData(id, options.itemsPerPage, options.itemsPerPage * (options.page - 1), JSONToSend);
                } else {
                    response = await UploadsService.getGroupedData(id, options.itemsPerPage, options.itemsPerPage * (options.page - 1));
                }
                commit('setGroupedData', response);
                if (response && response[0]) commit('setGroupedDataLength', Number(response[0].record_count));
                else commit('setGroupedDataLength', 0);
                return response;
            } catch (err) {
                console.error(err);
            } finally {
                commit('setGroupedDataLoading', false);
            }
        },

        async getFactData({ state, commit }, id) {
            try {
                commit('setFactDataLoading', true);
                const options = state.factDataPagination;
                let response;
                if (options.sortBy[0] || state.factDataFilter) {
                    const JSONToSend = getFilterObject(options, state.factDataFilter);
                    // функция с возможностью сортировки и фильтрации. Отправляем JSON с данными по фильтрации и сортировки
                    response = await UploadsService.getFactData(id, options.itemsPerPage, options.itemsPerPage * (options.page - 1), JSONToSend);
                } else {
                    response = await UploadsService.getFactData(id, options.itemsPerPage, options.itemsPerPage * (options.page - 1));
                }
                commit('setFactData', response);
                if (response && response[0]) commit('setFactDataLength', Number(response[0].record_count));
                else commit('setFactDataLength', 0);
                return response;
            } catch (err) {
                console.error(err);
            } finally {
                commit('setFactDataLoading', false);
            }
        },

        async confirmUpload({ commit }, id) {
            try {
                let response = await UploadsService.confirmUpload(id);
                return response ? { successfull: true } : { successfull: false };
            } catch (err) {
                console.error(err);
            }
        },

        async cancelUpload({ commit }, id) {
            try {
                let response = await UploadsService.cancelUpload(id);
                return response ? { successfull: true } : { successfull: false };
            } catch (err) {
                console.error(err);
            }
        }
    }
};
